export default __webpack_public_path__ + "static/media/third.277f49e6.png";